/** Point d'entrée de l'application. */

import { render } from 'preact';
import { App } from './ui/App';
import './ui/styles.css';

const root = document.getElementById('app');
if (root === null) throw new Error("L'élément racine #app est absent du document.");

render(<App />, root);
